const FEATURE_FLAG = Object.freeze({});

const FEATURE_FLAG_DEFAULTS = Object.freeze({});

export default FEATURE_FLAG_DEFAULTS;
export { FEATURE_FLAG_DEFAULTS, FEATURE_FLAG };
